export interface LegalSection {
  heading: string
  paragraphs: string[]
  bullets?: string[]
}

export const privacySections: LegalSection[] = [
  {
    heading: 'Introduction',
    paragraphs: [
      'This Privacy Policy explains how Futuramy Investment LLC ("Futuramy," "we," "us" or "our") may collect and handle information in connection with this website. It applies to this website only.',
      'By using this website, you acknowledge that you have read and understood this Privacy Policy.',
    ],
  },
  {
    heading: 'Information We May Collect',
    paragraphs: ['Depending on how you use this website, we may receive the following types of information:'],
    bullets: [
      'Contact form information — the name, email address, company, phone number and message details you choose to submit through the contact form.',
      'Website usage information — technical and usage details such as browser type, device type, referring pages and pages viewed, which may be recorded automatically.',
      'Cookies and similar technologies — where applicable, cookies or similar technologies may be used to support basic website functionality and to understand general website usage.',
    ],
  },
  {
    heading: 'How Information May Be Used',
    paragraphs: ['Information submitted through or collected by this website may be used to:'],
    bullets: [
      'Respond to business inquiries and professional communications.',
      'Maintain, operate and improve the website and its content.',
      'Understand general usage patterns of the website.',
      'Address technical issues, security matters or misuse of the website.',
    ],
  },
  {
    heading: 'How Information May Be Protected',
    paragraphs: [
      'We take reasonable administrative and technical measures intended to protect information submitted through this website against unauthorized access, use or disclosure. No method of transmission over the internet or electronic storage can be guaranteed to be completely secure, and we cannot guarantee absolute security.',
    ],
  },
  {
    heading: 'When Information May Be Shared',
    paragraphs: [
      'We do not sell information collected through this website. Information may be shared only in limited circumstances, including:',
    ],
    bullets: [
      'With service providers that support the operation of this website, to the extent necessary to perform those services.',
      'Where required by applicable law, regulation, legal process or governmental request.',
      'Where necessary to protect the rights, property or safety of Futuramy Investment LLC or others.',
    ],
  },
  {
    heading: 'Third-Party Services',
    paragraphs: [
      'This website may rely on third-party services for hosting, delivery of website resources, form handling, mapping or analytics. Those services may process limited technical information in accordance with their own privacy practices, and we do not control those practices.',
    ],
  },
  {
    heading: 'User Rights',
    paragraphs: [
      'You may request information about the personal details you have submitted through this website, ask that they be corrected, or ask that they be deleted. Requests may be submitted through the contact form on this website, and we will respond in a manner consistent with applicable law.',
      'You may also choose not to submit information through the contact form, and you may configure your browser to limit or refuse cookies. Certain website features may not function as intended if cookies are disabled.',
    ],
  },
  {
    heading: 'Data Retention',
    paragraphs: [
      'Information submitted through the contact form is retained only for as long as reasonably necessary to respond to the inquiry, to maintain business records, or as otherwise required for legitimate business or legal purposes. Information that is no longer needed may be deleted.',
    ],
  },
  {
    heading: 'Children',
    paragraphs: [
      'This website is intended for business and professional use and is not directed to children.',
    ],
  },
  {
    heading: 'Changes to This Privacy Policy',
    paragraphs: [
      'This Privacy Policy may be updated from time to time. Any updated version will be posted on this page with a revised update date.',
    ],
  },
  {
    heading: 'Contacting Us About Privacy',
    paragraphs: [
      'For questions or requests regarding this Privacy Policy, please use the contact form on this website or the business address and phone number listed on the Contact page.',
    ],
  },
]

export const termsSections: LegalSection[] = [
  {
    heading: 'Acceptance of Terms',
    paragraphs: [
      'These Terms of Use govern your access to and use of this website, which is operated by Futuramy Investment LLC. By accessing or using this website, you agree to these Terms of Use. If you do not agree, please discontinue use of the website.',
    ],
  },
  {
    heading: 'Website Use',
    paragraphs: [
      'You agree to use this website only for lawful purposes and in a manner that does not interfere with its operation or with other users. You agree not to attempt to gain unauthorized access to any portion of the website or to any systems or networks connected to it.',
    ],
  },
  {
    heading: 'Informational Purposes',
    paragraphs: [
      'The content of this website is provided for general informational purposes only. It does not constitute financial, legal, tax or investment advice, and it is not an offer, solicitation or recommendation of any kind. You should obtain independent professional advice before making any business decision.',
    ],
  },
  {
    heading: 'Intellectual Property',
    paragraphs: [
      'Unless otherwise indicated, the content, text, layout, design and marks appearing on this website are the property of Futuramy Investment LLC or are used with permission. You may view and print pages of this website for your own internal business reference. Any other reproduction, distribution or modification without prior written consent is not permitted.',
    ],
  },
  {
    heading: 'User Submissions',
    paragraphs: [
      'Information you submit through the contact form should be limited to what is necessary for your inquiry. You are responsible for the accuracy of the information you submit and agree not to submit unlawful, misleading or confidential third-party information. We may retain and use submissions as needed to respond to and record your inquiry.',
    ],
  },
  {
    heading: 'Third-Party Links',
    paragraphs: [
      'This website may contain links to or content from third-party websites or services. Those resources are provided for convenience only. We do not control and are not responsible for the content, availability or practices of any third-party resource.',
    ],
  },
  {
    heading: 'Disclaimer',
    paragraphs: [
      'This website and its content are provided on an "as is" and "as available" basis, without warranties of any kind, whether express or implied, to the fullest extent permitted by applicable law. We do not warrant that the website will be uninterrupted or error-free, or that the content is complete, current or accurate at all times.',
    ],
  },
  {
    heading: 'Limitation of Liability',
    paragraphs: [
      'To the fullest extent permitted by applicable law, Futuramy Investment LLC shall not be liable for any indirect, incidental, special, consequential or punitive damages, or for any loss arising out of your access to, use of, or inability to use this website or its content.',
    ],
  },
  {
    heading: 'Changes to the Website',
    paragraphs: [
      'We may modify, suspend or discontinue any part of this website, including its content and features, at any time and without notice.',
    ],
  },
  {
    heading: 'Changes to These Terms',
    paragraphs: [
      'These Terms of Use may be updated from time to time. The version posted on this page is the version in effect, and continued use of the website following an update constitutes acceptance of the updated terms.',
    ],
  },
  {
    heading: 'Contact Information',
    paragraphs: [
      'For questions regarding these Terms of Use, please use the contact form on this website or the business address and phone number listed on the Contact page.',
    ],
  },
]
